import { render, staticRenderFns } from "./Bgreviewone.vue?vue&type=template&id=9f7e5fd8&scoped=true&"
import script from "./Bgreviewone.vue?vue&type=script&lang=js&"
export * from "./Bgreviewone.vue?vue&type=script&lang=js&"
import style0 from "./Bgreviewone.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Bgreviewone.vue?vue&type=style&index=1&id=9f7e5fd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7e5fd8",
  null
  
)

export default component.exports